module.exports = __webpack_public_path__ + "img/services-icon-4.5b1779b1.png";